(function(){
  var T = window.theme || {};
  var $ = function(id){ return document.getElementById(id); };
  var money = function(cents){
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:T.currency || 'USD'}).format(cents/100); }
    catch(e){ return '$' + (cents/100).toFixed(2); }
  };
  var toastTimer;
  function toast(msg){ var t=$('toast'); if(!t) return; t.textContent=msg; t.hidden=false; clearTimeout(toastTimer); toastTimer=setTimeout(function(){t.hidden=true;},2000); }
  function setDrawer(open){ if(!$('drawer')) return; $('drawer').hidden=!open; $('veil').hidden=!open; }

  function renderBag(cart){
    if($('bag-count')) $('bag-count').textContent = cart.item_count;
    var list = $('bag-list'); if(!list) return;
    list.textContent = '';
    cart.items.forEach(function(item){
      var li = document.createElement('li');
      var left = document.createElement('span');
      left.appendChild(document.createTextNode(item.product_title + (item.quantity > 1 ? ' × ' + item.quantity : '')));
      if(item.variant_title && !item.product_has_only_default_variant){ var s=document.createElement('small'); s.textContent=item.variant_title; left.appendChild(s); }
      var rm = document.createElement('button'); rm.type='button'; rm.textContent='Remove';
      rm.addEventListener('click', function(){ changeItem(item.key, 0); });
      left.appendChild(rm);
      var right = document.createElement('span'); right.className='price'; right.textContent = money(item.final_line_price);
      li.appendChild(left); li.appendChild(right); list.appendChild(li);
    });
    $('bag-empty').hidden = cart.item_count > 0;
    $('bag-total').textContent = money(cart.total_price);
  }
  function loadBag(){
    return fetch(T.cartUrl + '.js', {headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){ renderBag(c); return c; });
  }
  function changeItem(key, quantity){
    fetch(T.cartChangeUrl + '.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({id:key, quantity:quantity})})
      .then(function(r){return r.json();}).then(renderBag).catch(function(){ window.location = T.cartUrl; });
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    fetch(T.cartAddUrl + '.js', {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)})
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(res){
        if(!res.ok){ toast(res.j.description || 'Could not add this item.'); return; }
        return loadBag().then(function(){ setDrawer(true); });
      })
      .catch(function(){ form.submit(); });
  });

  document.addEventListener('click', function(e){
    var open = e.target.closest('#bag-open');
    if(open && $('drawer')){ e.preventDefault(); loadBag().then(function(){ setDrawer(true); }).catch(function(){ window.location = T.cartUrl; }); return; }
    if(e.target.closest('#bag-close') || e.target.id === 'veil'){ setDrawer(false); return; }
    var thumb = e.target.closest('.thumb-btn');
    if(thumb && $('main-img')){ $('main-img').src = thumb.dataset.src; }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') setDrawer(false); });

  // Product page: match the chosen options to a variant.
  var data = $('product-variants');
  if(data){
    var variants = JSON.parse(data.textContent);
    var selects = Array.prototype.slice.call(document.querySelectorAll('select[data-option]'));
    var update = function(){
      var chosen = selects.map(function(s){ return s.value; });
      var v = variants.filter(function(x){ return x.options.every(function(o,i){ return o === chosen[i]; }); })[0];
      var btn = $('add-btn');
      if(!v){ btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      $('variant-id').value = v.id;
      $('product-price').textContent = money(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      if(v.featured_image && $('main-img')) $('main-img').src = v.featured_image.src;
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch(e){}
    };
    selects.forEach(function(s){ s.addEventListener('change', update); });
  }
})();
